import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { AssignOrderSchema } from "../../../ValidationSchema";
import ReactSelect from "../../../Components/PortalSelect";
const colourStyles = {
  control: (styles) => ({
    ...styles,
    border: "1px solid #bfc9d4",
    boxShadow: "#000 !important",
    borderRadius: "6px",
    padding: "4px",
    "&:hover": {
      border: "1px solid #bfc9d4",
    },
  }),
  multiValue: (styles) => {
    return {
      ...styles,
      backgroundColor: "#606060",
    };
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: "#000",
    "& > svg": {
      backgroundColor: "#fff",
      borderRadius: "10px",
      marginLeft: "2px",
      marginRight: "2px",
    },
    ":hover": {
      backgroundColor: data.color,
      color: data.color,
    },
  }),
  option: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: "white",
      color: "#000",
      ":hover": {
        backgroundColor: "#f5f5f5",
      },
    };
  },
};

const AssignCodeAdd = () => {
  const [orderData, setOrderData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const location = useLocation();
  const orderIdFromState = location?.state?.orderId;

  const Navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    order_id: "",
    supplier_id: [],
    remark: "",
    status: "Pending",
  });

  useEffect(() => {
    if (orderIdFromState) {
      setInitialValues((prev) => ({
        ...prev,
        order_id: orderIdFromState,
        status: "Pending", // or keep as is
      }));
    }
  }, [orderIdFromState]);

  const AssignCodeData = () => {
    axios
      .get(`${process.env.REACT_APP_URL}/admin/orders/get`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((res) => {
        setOrderData(
          res?.data?.data?.desc.map((item) => {
            return {
              label: item?.title || "Untitled", // fallback if title is undefined
              value: item?.id,
            };
          })
        );
      })
      .catch((err) => {
        if (err.response.data.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const SupplierData = () => {
    axios
      .get(`${process.env.REACT_APP_URL}/admin/connection`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((res) => {
        setSupplierData(
          res?.data?.data?.desc.map((item) => {
            return {
              label: item?.user?.name || "Untitled", // fallback if title is undefined
              value: item?.user?.id,
            };
          })
        );
      })
      .catch((err) => {
        if (err.response.data.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const AddRole = useFormik({
    initialValues,
    enableReinitialize: true, // important when initialValues come from async data
    validationSchema: AssignOrderSchema,

    onSubmit: (values, action) => {
      const payload = {
        ...values,
        order_id: orderIdFromState != null ? orderIdFromState : values.order_id,
        suppliers: values.supplier_id,
        status: orderIdFromState ? "Pending" : values.status,
      };

      axios
        .post(
          `${process.env.REACT_APP_URL}/admin/assigned-orders/store`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            toast.success(`${res?.data?.message}`);
            Navigate("/admin/buyer/list", { state: res.data.msg });
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg);
        });
    },
  });

  useEffect(() => {
    AssignCodeData();
    SupplierData();
  }, [orderIdFromState]);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Assign Order</h1>
          <p className="al-sub">Assign an order to one or more suppliers.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={AddRole.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><rect x="8" y="2" width="8" height="4" rx="1" /></svg></div>
            <h3 className="al-cardhead__title">Assignment Details</h3>
          </div>
          <div className="al-form">
            {!orderIdFromState && (
              <div>
                <label className="al-label">Order</label>
                <ReactSelect
                  options={orderData}
                  isClearable={false}
                  styles={colourStyles}
                  components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                  placeholder="Select Order"
                  name="order_id"
                  onChange={(e) => AddRole?.setFieldValue("order_id", e?.value)}
                  value={orderData.find((item) => item.value === AddRole.values.order_id) || null}
                />
                {AddRole?.errors?.order_id && AddRole?.touched?.order_id && (
                  <div className="al-err">{AddRole?.errors?.order_id}</div>
                )}
              </div>
            )}

            <div>
              <label className="al-label">Supplier</label>
              <ReactSelect
                isMulti
                options={supplierData}
                isClearable={false}
                styles={colourStyles}
                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                placeholder="Select Supplier"
                name="supplier_id"
                onChange={(selected) => {
                  const values = selected ? selected.map((option) => option.value) : [];
                  AddRole?.setFieldValue("supplier_id", values);
                }}
                value={AddRole?.values?.supplier_id
                  ?.map((id) => supplierData.find((item) => item.value === id) || null)
                  .filter(Boolean)}
              />
              {AddRole?.errors?.supplier_id && AddRole?.touched?.supplier_id && (
                <div className="al-err">{AddRole?.errors?.supplier_id}</div>
              )}
            </div>

            {!orderIdFromState && (
              <div>
                <label className="al-label">Order Status</label>
                <ReactSelect
                  options={[
                    { label: "Pending", value: "Pending" },
                    { label: "Completed", value: "Completed" },
                  ]}
                  isClearable={false}
                  styles={colourStyles}
                  components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                  placeholder="Select Status"
                  name="status"
                  onChange={(e) => AddRole?.setFieldValue("status", e?.value)}
                />
                {AddRole?.errors?.status && AddRole?.touched?.status && (
                  <div className="al-err">{AddRole?.errors?.status}</div>
                )}
              </div>
            )}
          </div>
          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              Assign Order
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AssignCodeAdd;
